import React from 'react'
import styled from 'styled-components'

import Color from 'helpers/Color'
import Comfort from 'helpers/Comfort'

const Wrapper = styled.div`
  zoom: ${({ small }) => small ? 0.75 : 1};
`
const LegendItem = styled.div`
  display: inline-block;
  font-weight: 600;
  margin-right: 1.5em;
`
const Square = styled.div`
  width: 12px;
  height: 12px;
  float: left;
  margin-right: .5em;
  margin-top: 4px;
`
const Hint = styled.div`
  text-align: right;
  color: ${Color.gray};
  margin-top: -1px;
  font-weight: 300;
`

const items = [
  {
    label: Comfort.cold,
    hint: '< 70',
    color: Color.blue,
  },
  {
    label: Comfort.cozy,
    hint: '70 - 75',
    color: Color.green,
  },
  {
    label: Comfort.warm,
    hint: '75 - 80',
    color: Color.orange,
  },
  {
    label: Comfort.hot,
    hint: '> 80',
    color: Color.red,
  },
]

const TemperatureLegend = ({ small }) => (
  <Wrapper small={small}>
    { items.map((item, i) =>
      <LegendItem key={i}>
        {item.label}
        <Square style={{backgroundColor: item.color}} />
        <Hint>{item.hint}</Hint>
      </LegendItem>
    )}
  </Wrapper>
)

export default TemperatureLegend



// WEBPACK FOOTER //
// ./src/components/UI/Chart/TemperatureLegend.jsx